<div class="kb-page">

    <div>

        <div class="mx-auto max-w-3xl">
            <div class="" *ngIf="!idEjecutive">
                <h1 class="kb-page-title flex items-center gap-2"><i class="fas fa-user-tie text-muted-foreground" aria-hidden="true"></i>Identificate para vender
                </h1>
                <p class="kb-page-desc mb-4">La venta queda registrada a tu nombre: ingresá tu cédula para empezar.</p>



                <ng-container *ngIf="rate_error">
                    <div class="kb-aviso kb-aviso-peligro"><i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i><div><p class="kb-aviso-titulo">No se pudo obtener la tasa de cambio</p><p>Sin tasa no se puede calcular el crédito. Volvé a intentar en un momento.</p></div></div>
                </ng-container>

                <ng-container *ngIf="!rate_error && !rate_load">

                    <ng-container *ngIf="section == 1">

                        <div class="kb-card mt-4 p-6">

                            <form autocomplete="nope" novalidate [formGroup]="formEjecutive" (ngSubmit)="setIdEjecutive()" class="text-start">
                                <div class="row mt-3">


                                    <div class="form-group  col-4 mt-3">

                                        <div class="form-floating">
                                            <select [ngClass]="{'error': formEjecutive.controls.code_identity.invalid && formEjecutive.controls.code_identity.dirty}" class="form-select" id="code_identity" formControlName="code_identity" aria-label="Floating label select example">
                            <option  value="">Selecione</option>
                            <option *ngFor="let item of code_identity"  [value]="item.code">{{item.name}}</option>
                                     </select>



                                            <label for="code_identity">Tipo</label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="formEjecutive.get('code_identity').errors">
                                            <div *ngIf="formEjecutive.get('code_identity').errors['required'] && !formEjecutive.get('code_identity').pristine">
                                                Campo requerido
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group  col-8  mt-3">

                                        <div class="form-floating ">
                                            <input type="text" [ngClass]="{'error': formEjecutive.controls.identity.invalid && formEjecutive.controls.identity.dirty}" class="form-control text-capitalize" id="identity" formControlName="identity">
                                            <label for="identity" class=" label font-weight-normal" style="word-wrap: break-word;">
                          <span >Número </span>
                     </label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="formEjecutive.get('identity').errors">
                                            <div *ngIf="formEjecutive.get('identity').errors['required'] && !formEjecutive.get('identity').pristine">
                                                Campo requerido
                                            </div>

                                            <div *ngIf="formEjecutive.get('identity').hasError('minlength')  && !formEjecutive.get('identity').pristine">
                                                Mínimo 6 caracteres
                                            </div>

                                            <div *ngIf="formEjecutive.get('identity').hasError('maxlength')  && !formEjecutive.get('identity').pristine">
                                                Máximo 8 caracteres
                                            </div>

                                        </div>
                                    </div>
                                    <div class="form-group  col-12 mt-4 mb-2">
                                        <div class=" float-end">

                                            <button type="submit" [disabled]="!formEjecutive.valid || submit_disabled" class="btn btn-block btn-primary ">
                                        <span >Continuar</span>
                                        <span *ngIf="submit_disabled">
                                          <i class="fa  fa-spinner fa-spin ms-2"></i>
                                        </span>
                                       </button>

                                        </div>

                                    </div>

                                    <hr *ngIf="errorMsg" class="mt-2">

                                </div>
                            </form>


                        </div>
                    </ng-container>
                </ng-container>

            </div>
            <div class="" *ngIf="idEjecutive">


                <h1 class="kb-page-title flex items-center gap-2"><i class="fas fa-cart-plus text-muted-foreground" aria-hidden="true"></i>Crear compra financiada
                    <button *ngIf="section > 1" (click)="resetData()" type="button"
                            class="kb-btn kb-btn-ghost kb-btn-icon ml-auto" title="Empezar de nuevo">
                        <i class="fas fa-times" aria-hidden="true"></i></button>

                </h1>


                <ng-container *ngIf="rate_load">
                    <div class="w-100 text-center text-md-start">
                        <img src="./assets/public/images/loading.gif  " alt=" ">
                    </div>
                </ng-container>

                <ng-container *ngIf="rate_error">
                    <div class="kb-aviso kb-aviso-peligro"><i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i><div><p class="kb-aviso-titulo">No se pudo obtener la tasa de cambio</p><p>Sin tasa no se puede calcular el crédito. Volvé a intentar en un momento.</p></div></div>
                </ng-container>

                <ng-container *ngIf="!rate_error && !rate_load">
                    <ng-container *ngIf="viewForm">
                        <div class="kb-card mt-4 p-6">

                            <form autocomplete="nope" novalidate [formGroup]="form" (ngSubmit)="submit()" class="text-start">
                             
                                <div class="row mt-3">

                                    <!-- <div class=" mt-4 fw-bold">Planes</div>
                                    <div class="form-group  col-12 mt-3">
                                        <div class="form-floating">
                                            <select (change)="searchPerson = null" [ngClass]="{'error': form.controls.plan.invalid && form.controls.plan.dirty}" class="form-select" id="plan" formControlName="plan" aria-label="Floating label select example">
                                                <option  value="">Selecione</option>
                                                <option *ngFor="let item of plans"  [value]="item._id">{{item.name}}</option> 

                                     </select>
                                            <label for="currency">Plan</label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="form.get('plan').errors">
                                            <div *ngIf="form.get('plan').errors['required'] && !form.get('plan').pristine">
                                                Campo requerido
                                            </div>
                                        </div>
                                    </div> 


                                    
                                    <div class="form-group  col-12 col-md-6  mt-3">

                                        <div class="form-floating ">
                                            <input (keyup)="searchPerson = null" type="text" [ngClass]="{'error': form.controls.item.invalid && form.controls.item.dirty}" class="form-control text-capitalize" id="item" formControlName="item">
                                            <label for="item" class=" label font-weight-normal" style="word-wrap: break-word;">
                                        <span >Código del Producto (UBi)</span>
                                    </label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="form.get('item').errors">
                                            <div *ngIf="form.get('item').errors['required'] && !form.get('item').pristine">
                                                Campo requerido
                                            </div>
                                        </div>
                                    </div>-->

      <!-- 
                                    <div class=" mt-2 fw-bold">Documento</div>

                                    <div class="form-group  col-12 col-md-6 mt-3">
                                        <div class="form-floating">
                                            <select [ngClass]="{'error': form.controls.currency.invalid && form.controls.type_invoice.dirty}" class="form-select" id="type_invoice" formControlName="type_invoice" aria-label="Floating label select example">
                                            <option  value="invoice">Factura</option>
                                     </select>
                                            <label for="currency">Tipo documento</label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="form.get('type_invoice').errors">
                                            <div *ngIf="form.get('currency').errors['required'] && !form.get('type_invoice').pristine">
                                                Campo requerido
                                            </div>
                                        </div>

                                    </div>



                             <div class="form-group  col-12 col-md-6  mt-3">

                                        <div class="form-floating ">
                                            <input (keyup)="searchPerson = null" type="text" [ngClass]="{'error': form.controls.invoice.invalid && form.controls.invoice.dirty}" class="form-control text-capitalize" id="invoice" formControlName="invoice">
                                            <label for="invoice" class=" label font-weight-normal" style="word-wrap: break-word;">
                                        <span >Código documento</span>
                                    </label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="form.get('invoice').errors">
                                            <div *ngIf="form.get('invoice').errors['required'] && !form.get('invoice').pristine">
                                                Campo requerido
                                            </div>
                                        </div>
                                    </div>
--> 
                                    <!-- <div class="form-group  col-12 col-md-6  mt-3">

                                        <div class="form-floating ">
                                            <input (keyup)="searchPerson = null" type="text" [ngClass]="{'error': form.controls.invoice_oddo.invalid && form.controls.invoice_oddo.dirty}" class="form-control text-capitalize" id="invoice_oddo" formControlName="invoice_oddo">
                                            <label for="invoice_oddo" class=" label font-weight-normal" style="word-wrap: break-word;">
                                        <span >Código contabilidad</span>
                                    </label>
                                        </div>

                                        <div class="form-control-feedback help-block" *ngIf="form.get('invoice_oddo').errors">
                                            <div *ngIf="form.get('invoice_oddo').errors['required'] && !form.get('invoice_oddo').pristine">
                                                Campo requerido
                                            </div>
                                        </div>
                                    </div> -->



                                    <p class="kb-section-title mt-4">Datos del cliente</p>

                                    <div class="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-3">
                                        <div>
                                            <label class="kb-label" for="code_identity">
                                                Tipo <span class="text-destructive">*</span>
                                            </label>
                                            <div class="kb-select-envoltorio">
                                                <select id="code_identity" class="kb-select"
                                                        formControlName="code_identity"
                                                        (change)="searchPerson = null"
                                                        [ngClass]="{'kb-input-invalido': form.controls.code_identity.invalid && form.controls.code_identity.dirty}">
                                                    <option value="">Seleccioná</option>
                                                    <option *ngFor="let item of code_identity" [value]="item.code">{{item.name}}</option>
                                                </select>
                                                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div class="sm:col-span-2">
                                            <label class="kb-label" for="identity">
                                                Número de cédula <span class="text-destructive">*</span>
                                            </label>
                                            <input id="identity" type="text" class="kb-input font-mono"
                                                   formControlName="identity" (keyup)="searchPerson = null"
                                                   [ngClass]="{'kb-input-invalido': form.controls.identity.invalid && form.controls.identity.dirty}">
                                        </div>
                                    </div>

                                    <!-- ══ DÓNDE SE VENDE ═══════════════════════════════════
                                         🔴 La tienda define el COMERCIO de la venta, y de eso
                                         depende a quién se le liquida. Antes salía del usuario
                                         de la sesión y, si no tenía, de un número escrito a
                                         mano: una venta de EPA podía quedar en MundoTotal. -->
                                    <p class="kb-section-title mt-4">Dónde se vende</p>
                                    <p class="kb-hint mb-3">
                                        La tienda define el comercio de la venta, y con eso
                                        <b>a quién se le liquida</b>.
                                    </p>

                                    <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                                        <div>
                                            <label class="kb-label" for="tiendaVenta">
                                                Tienda <span class="text-destructive">*</span>
                                            </label>
                                            <div class="kb-select-envoltorio">
                                                <select id="tiendaVenta" class="kb-select"
                                                        [(ngModel)]="tiendaSeleccionada"
                                                        [ngModelOptions]="{standalone: true}"
                                                        (ngModelChange)="searchPerson = null">
                                                    <option [ngValue]="null">Elegí la tienda…</option>
                                                    <option *ngFor="let t of tiendas" [ngValue]="t.code">
                                                        {{ t.code }} — {{ t.short_name || t.name }}
                                                    </option>
                                                </select>
                                                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                                            </div>
                                            <p class="kb-hint" *ngIf="cargandoTiendas">Cargando tiendas…</p>
                                        </div>
                                        <div>
                                            <span class="kb-label">Comercio de la venta</span>
                                            <p class="kb-input flex items-center">
                                                <span *ngIf="comercioDeLaVenta">{{ comercioDeLaVenta }}</span>
                                                <span class="text-muted-foreground" *ngIf="!comercioDeLaVenta">
                                                    se define por la tienda
                                                </span>
                                            </p>
                                        </div>
                                    </div>

                                    <div class="kb-aviso kb-aviso-alerta mt-3" *ngIf="!tiendas.length && !cargandoTiendas">
                                        <i class="fas fa-exclamation-triangle mt-0.5" aria-hidden="true"></i>
                                        <div>
                                            <p class="kb-aviso-titulo">Este comercio no tiene tiendas activas</p>
                                            <p>Sin tienda la venta quedaría sin comercio y no se le podría liquidar a nadie.</p>
                                        </div>
                                    </div>

                                    <p class="kb-section-title mt-4">Datos de la operación</p>

                                    <div class="mt-3 grid grid-cols-1 gap-4 sm:grid-cols-2">
                                        <div>
                                            <label class="kb-label" for="currency">Moneda</label>
                                            <div class="kb-select-envoltorio">
                                                <select id="currency" class="kb-select" formControlName="currency"
                                                        (change)="searchPerson = null"
                                                        [ngClass]="{'kb-input-invalido': form.controls.currency.invalid && form.controls.currency.dirty}">
                                                    <option value="BS">Bolívares</option>
                                                    <option value="USD">Dólares</option>
                                                </select>
                                                <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <label class="kb-label" for="total_amount">
                                                Monto total <span class="text-destructive">*</span>
                                            </label>
                                            <input id="total_amount" type="text"
                                                   class="kb-input text-right tabular-nums"
                                                   formControlName="total_amount" currencyMask
                                                   [options]="{ prefix: form?.getRawValue()?.currency + ' ', thousands: ',', decimal: '.' }"
                                                   (keyup)="searchPerson = null" (click)="moveCursorToEnd($event)"
                                                   [ngClass]="{'kb-input-invalido': form.controls.total_amount.invalid && form.controls.total_amount.dirty}">
                                        </div>
                                    </div>

                                    <dl class="kb-kv mt-4">
                                        <div>
                                            <dt class="kb-kv-label">Tasa de cambio</dt>
                                            <dd class="kb-kv-valor tabular-nums">
                                                USD 1 = BS {{ rate?.amount | currency:'':'':'1.2-2' }}
                                            </dd>
                                        </div>
                                    </dl>

                                    <div class="mt-6 flex flex-wrap items-center justify-between gap-3">
                                        <p class="kb-barra-nota">
                                            <span class="kb-td-alerta font-medium" *ngIf="!tiendaSeleccionada">
                                                <i class="fas fa-exclamation-triangle" aria-hidden="true"></i>
                                                Falta elegir la tienda
                                            </span>
                                            <span *ngIf="tiendaSeleccionada && comercioDeLaVenta">
                                                La venta se registra en {{ comercioDeLaVenta }}
                                            </span>
                                        </p>
                                        <button type="submit" class="kb-btn kb-btn-primary"
                                                [disabled]="searchPerson || !tiendaSeleccionada || !(form?.getRawValue()?.total_amount > 0) || !form.valid || submit_disabled">
                                            <i class="fas" [ngClass]="submit_disabled ? 'fa-spinner fa-spin' : 'fa-search'"
                                               aria-hidden="true"></i>
                                            {{ submit_disabled ? 'Consultando…' : 'Consultar' }}
                                        </button>

                                    </div>

                                    <hr *ngIf="errorMsg" class="mt-2">

                                    <div *ngIf="errorMsg" class="kb-error">
                                        {{errorMsg}}
                                    </div>

                                </div>
                            </form>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="submit_disabled ">
                        <div class="w-100 text-center text-md-start">
                            <img src="./assets/public/images/loading.gif  " alt=" ">
                        </div>
                    </ng-container>

                    <ng-container *ngIf=" !submit_disabled &&  !errorMsg && searchPerson">

                        <div class="mt-5 my-3 p-3 bg-body rounded shadow-sm">


                            <div class="">
                                <div class="d-flex mb-4">

                                    <div class="">
                                        <button (click)="currencyResponse = 'BS'" [ngClass]="{'btn-secondary': currencyResponse == 'BS','btn-outline-secondary': currencyResponse != 'BS'}" class=" me-2 btn btn-sm">
                                        <span >BS</span>
                                    </button>

                                        <button (click)="currencyResponse = 'USD'" [ngClass]="{'btn-secondary': currencyResponse == 'USD','btn-outline-secondary': currencyResponse != 'USD'}" class="btn btn-sm">
                                        <span >Dolares</span>
                                    </button>

                                    </div>
                                </div>

                                <div>
                                    <span class=" text-secondary">Tipo de documento: </span>
                                    <span class=" text-dark ms-auto"> Factura </span>
                                </div>

                                <div class="mt-2">
                                    <span class=" text-secondary">Código de documento: </span>
                                    <span class=" text-dark ms-auto"> {{form?.getRawValue()?.invoice}} </span>
                                </div>

                                <!-- <div class="mt-2">
                                    <span class=" text-secondary">Código de contabilidad: </span>
                                    <span class=" text-dark ms-auto"> {{form?.getRawValue()?.invoice_oddo}} </span>
                                </div> -->

                                <div class="mt-2">
                                    <span class=" text-secondary">Cliente: </span>
                                    <span class=" text-dark ms-auto text-capitalize"> {{searchPerson?.person?.name}} {{searchPerson?.person?.lastName}}  </span>
                                </div>

                                <div class="mt-2">
                                    <span class=" text-secondary">Monto Total: </span>
                                    <span class=" text-dark"> {{searchPerson?.total_currency[currencyResponse]?.total_amount | currency:currencyResponse:'': '1.2-2'}} <span class="small">{{currencyResponse}}</span></span>
                                </div>

                                <div class="mt-2">
                                    <span class=" text-secondary">Monto Inicial: </span>
                                    <span class=" text-dark"> {{searchPerson?.total_currency[currencyResponse]?.initiala_amount | currency:currencyResponse:'': '1.2-2'}} <span class="small">{{currencyResponse}}</span></span>
                                </div>

                                <div class="mt-3">


                                    <div>
                                        Planes Aplicables
                                    </div>
                                    <ul class="small">
                                        <li *ngFor="let item of searchPerson?.listPlans; let i=index" >
                                            {{item}}
                                        </li>
                                    </ul>

                                    <div class=" text-secondary" *ngIf="getobjPlans">Plan: <a href="/" class="text-primary ps-2" disbled="true">Editar</a></div>
                                    <div class=" text-dark ms-auto text-capitalize mt-2 fw-bold"> {{getobjPlans()?.name}}</div>
   <!-- 
                                    <div class="mt-2">
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2 ">Monto minimo : {{getobjPlans()?.min_amount}} USD</span>
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2">Cuotas minimas  : {{getobjPlans()?.min_number_installment}}</span>
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2">Inicial  : {{getobjPlans()?.initial_installMent?'Si':'No'}}</span>
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2" *ngIf="getobjPlans()?.initial_installMent">Monto inicial : {{getobjPlans()?.amount_initial_installMent}}{{getobjPlans()?.type_amount_initial_installMent == 'P'?'%':' USD'}}</span>
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2 " *ngIf="!getobjPlans()?.item?.calendar">Cuota cada: {{getobjPlans()?.calendar_time}}D</span>
                                        <span class=" mt-2 badge rounded-pill bg-secondary2 me-2">Recalculado de inicial  : {{getobjPlans()?.recalculate_initial?'Si':'No'}}</span>
                                    </div>
-->


                                </div>


                                <div class=" d-flex text-dark pt-4 " *ngFor=" let item of searchPerson?.installments;let i = index">
                                    <div class="pb-3 mb-0 small lh-sm border-bottom  w-100">
                                        <div class="d-flex justify-content-between">
                                            <div class="">

                                                <div class="text-secondary text-capitalize fw-bold ">
                                                    {{ item?.order
                                                    < 1 ? 'Inicial': 'cuota '+item?.order}}</div>

                                                        <div class="text-secondary text-capitalize small pt-1">
                                                            {{item?.scheduledPaymentDate | date: 'dd/MM/yyyy'}}
                                                        </div>

                                                </div>
                                                <div class="ms-auto">


                                                    <div class=" fw-bold">{{item?.amount | currency:'USD':'': '1.2-2'}} USD </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>




                                <div class=" mt-5 d-grid gap-2">
                                    <button [disabled]="submit_download_create" (click)="creditSave()" class="btn  btn-primary " *ngIf="!pagare">
                                    <span > Crear </span>
                                    <span *ngIf="submit_download_create">
                                    <i class="fa  fa-spinner fa-spin ms-2"></i>
                                    </span>
                                </button>
                                    <!-- <button [disabled]="submit_download_disabled" (click)="downloadFile(pagare.url, 'pdf', idInvoice+'.pdf')" class="btn  btn-primary btn-block" *ngIf="pagare">
                                    <span > Descargar Pagaré </span>
                                    <span *ngIf="submit_download_disabled">
                                        <i class="fa  fa-spinner fa-spin ms-2"></i>
                                    </span>
                                </button> -->

                                    <button [disabled]="submit_download_disabled" (click)="continuar()" class="btn btn-block btn-outline-primary" *ngIf="pagare">
                                            <span > Continuar </span>
                                            
                                        </button>




                                </div>
                            </div>



                    </ng-container>

                    <ng-container *ngIf="section == 3">

                        <div class="ms-auto me-auto mt-3 mb-3 bg-body rounded shadow-sm rounded-circle avatar">
                            <img *ngIf="searchPerson?.person?.gender != 'F'" class="rounded-circle  " [src]="sanitize('../assets/public/images/avatar.png')">
                            <img *ngIf="searchPerson?.person?.gender == 'F'" class="rounded-circle  " [src]="sanitize('../assets/public/images/avatara-female.png')">

                        </div>

                        <div class="text-center mb-5">
                            <div class="text-capitalize h4 text-dark">{{searchPerson?.person?.name}} {{searchPerson?.person?.lastName}}</div>
                            <div> {{identityResponse}}</div>
                        </div>

                        <div class="kb-card mt-4 p-6">
                            <div class="row rmt-2">
                                <div class="col-12">
                                    <div class="float-end">
                                        <button (click)="currencyResponse = 'BS'" [ngClass]="{'btn-secondary': currencyResponse == 'BS','btn-outline-secondary': currencyResponse != 'BS'}" class=" me-2 btn btn-sm">
                                        <span >BS</span>
                                    </button>

                                        <button (click)="currencyResponse = 'USD'" [ngClass]="{'btn-secondary': currencyResponse == 'USD','btn-outline-secondary': currencyResponse != 'USD'}" class="btn btn-sm">
                                        <span >Dolares</span>
                                    </button>

                                    </div>
                                    <div class="small text-secondary">Credito total</div>
                                    <h5 class="fw-bolder text-dark">{{searchPerson?.total_currency[currencyResponse]?.total_amount | currency:currencyResponse:'': '1.2-2'}} <span class="small">{{currencyResponse}}</span></h5>
                                </div>


                                <div class="col-6">
                                    <div class="small text-secondary">ID Transaccion</div>
                                    <div class=" text-dark">{{idInvoice }}</div>
                                </div>

                                <div class="col-6 text-end">
                                    <div class="small text-secondary">Estatus</div>
                                    <div class="text-dark">Pendiente</div>
                                </div>
                                <div class="col-12 ">
                                    <div class="small text-secondary">Plan</div>
                                    <div class="text-dark">50% Inicial min.</div>
                                </div>
                                <div class="col-12">
                                    <div class="small text-secondary">Cuotas</div>
                                    <div class=" text-dark">3</div>
                                </div>
                                <div class="col-6 ">
                                    <div class="small text-secondary">Inicial</div>
                                    <div class=" text-dark">{{searchPerson?.total_currency[currencyResponse]?.initiala_amount | currency:currencyResponse:'': '1.2-2'}} <span class="small">{{currencyResponse}}</span></div>
                                </div>

                                <div class="col-6 text-end">
                                    <div class="small text-secondary">Total pendiente</div>
                                    <div class=" text-dark">{{searchPerson?.outstanding_balance | currency:'USD':'': '1.2-2'}} USD</div>

                                </div>
                            </div>
                        </div>
                    </ng-container>

                </ng-container>

                </div>
            </div>
        </div>
    </div>